import React, {useState} from 'react';
import CybsDialog from '@cybs-ui/components/lib/dialog';
import Textfield from '@cybs-ui/components/lib/textfield';
import CybsLoader from '@cybs-ui/components/lib/loader';
import CybsButton from '@cybs-ui/components/lib/button';
import Link from '@visa/vds/link';
import {getSuccessStatus, getSuccessMessage, getCurrentAuthType, getLoaderCloseFlag} from '../../../lhs/reducers/configuration-reducer';
import {showDivBasedOnId,hideDivBasedOnId, isDefaultSite} from '../../../commons/ui-commons';
import { getPartnerConfigVal } from '../../../libs/common-library.js';
import validateCredentialsAndCallKMSAPI from './kms-functions';
import {getCredCookie} from '../../../commons/cookie';
import {useSelector} from 'react-redux';
import $ from 'jquery';
import {ReactComponent as CybsLogo} from '../../../images/logo.svg'
import { putDataInDevCenterDataStore } from '../../../app/store';

function handleKMSGenerateKeys(orgId, username, password, setOpenLoader, setPositiveAlert, setNegativeAlert, changeOpenState, setP12){
  validateCredentialsAndCallKMSAPI(orgId, username, password);
  putDataInDevCenterDataStore({type: 'UPDATE_LOADER_CLOSE_FLAG', loaderCloseFlag: false});
  setOpenLoader(true);
  changeOpenState(false);
  setTimeout(function(){
   if(!getLoaderCloseFlag()){
    var successStatus = getSuccessStatus();
    var successMessage = getSuccessMessage();
    if(successStatus == "fail"){
      setPositiveAlert({visible: false, message: ''})
      setNegativeAlert({visible: true, message: successMessage})
      setTimeout(function() {
        setNegativeAlert({visible: false, message: ''});
      },10000);
    }
    else{
      setNegativeAlert({visible: false, message: ''});
      setPositiveAlert({visible: true, message: successMessage});
      setTimeout(function() {
        setPositiveAlert({visible: false, message: ''});
      },10000);
      if(getCurrentAuthType() === 'HTTP Signature'){
        showDivBasedOnId('updated-creds-http-api');
        showDivBasedOnId('updated-creds-http-endpoint');
        hideDivBasedOnId('default-creds-http-api');
        hideDivBasedOnId('default-creds-http-endpoint');
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_HTTP_MERCHANT_ID', currentHTTPMerchantId: getCredCookie('merchantId')});
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_KEY_ID', currentKeyId: getCredCookie('key')});
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_SECRET_KEY', currentSecretKey: getCredCookie('secretKey')});
      }
      else{
        showDivBasedOnId('updated-creds-jwt-api');
        showDivBasedOnId('updated-creds-jwt-endpoint');
        hideDivBasedOnId('default-creds-jwt-api');
        hideDivBasedOnId('default-creds-jwt-endpoint');
        putDataInDevCenterDataStore({type: 'UPDATE_CURRENT_JWT_MERCHANT_ID', currentSecretKey: getCredCookie('jwtMerchantId')});
        var p12key = sessionStorage.getItem('jwttoken')
        let p12blob = new Blob([p12key], {type: 'application/x-pkcs12;base64'})
        var p12File = new File([p12blob], getCredCookie('jwtMerchantId')+'.p12');
        setP12([p12File]);
        let merchantIdCookieVal = getCredCookie('jwtMerchantId');
        document.querySelector("#static-api-endpoints-section .jwtDiv .file-upload input").previousElementSibling.textContent = merchantIdCookieVal + '.p12';
        document.querySelector("#dynamic-rhs .jwtDiv .file-upload input").previousElementSibling.textContent = merchantIdCookieVal + '.p12';
      }
    }
   }
   setOpenLoader(false);
  },5000);
  
}

const KmsDialog = (props) => {
    const [orgId, setOrgId] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [orgIdState, setOrgIdState] = useState({
        errorText: '',
        invalid: false
    });
    const [usernameState, setUsernameState] = useState({
        errorText: '',
        invalid: false
    });
    const [passwordState, setPasswordState] = useState({
        errorText: '',
        invalid: false
    });
    const [disabled, setDisabled] = useState(true);
    const [icon, setIcon] = useState('password-show');
    const [type, setType] = useState('password');
    const [openLoader, setOpenLoader] = useState(false);
    const [dialogActive, setDialogActive] = useState(false);
    const closeLoader = () => {
      setOpenLoader(false);
      putDataInDevCenterDataStore({type: 'UPDATE_LOADER_CLOSE_FLAG', loaderCloseFlag: true});
    }
    const closeDialog = () => {
      props.changeOpenState(false);
      setDialogActive(false);
      if(type === 'text'){
        setType('password')
        setIcon('password-show');
      }
    }
    var currentAuthType = useSelector(state => state.configurationReducer.currentAuthType);
    var buttonLabel = (currentAuthType === 'HTTP Signature')?'Generate Keys':'Generate Certificate';
    React.useEffect(function switchState() {
      if(currentAuthType === 'HTTP Signature'){
        buttonLabel = 'Generate Keys';
      }
      else{
        buttonLabel = 'Generate Certificate'
      }
    }, [currentAuthType])
    React.useEffect(function switchState() {
      if(orgId.length&&username.length&&password.length){
          setDisabled(false);
        }
      else{
          setDisabled(true);
      }
  },[orgId,username,password])
  React.useEffect(function switchState(){
    setOrgId('');
    setUsername('');
    setPassword('');
  },[props.openState])
  var imageComp,copyValue;
  if(!isDefaultSite()){
    imageComp = <div id='whitelabeled-logo' style={{height: '60px', width:'100%'}}></div>;
  }
  else{
    imageComp = <CybsLogo />;           
    copyValue = "\u00A9 Cybersource 2020";
  }
    return(
      <div>
        <CybsDialog 
           isOpen={openLoader}
           dataTest="kms-loader"
           body={
            <div>
           <div id="close-button">
             <CybsButton
              variant="icon"
              dataTest="closeButton"
              iconClass="close"
              iconType="light-tiny"
              resolution="tiny"
              colorScheme="secondary"
              readOnly
              onClick={closeLoader}
              style={{float: "right"}}
             />
            </div>
            <br/><br/>
            <div id="loader-spinner" style={{display: "flex", justifyContent: "center", marginTop: "180px"}}>
            <CybsLoader 
              isVisible
            />
            </div>
             </div>

           }
        />
        <CybsDialog
            dataTest = "kms-dialog"
            isOpen={props.openState}
            body={
            <div>
            <div>
            <CybsButton
              variant="icon"
              dataTest="closeButton"
              iconClass="close"
              iconType="light-tiny"
              resolution="tiny"
              colorScheme="secondary"
              readOnly
              onClick={closeDialog}
              style={{float: "right"}}
             />
            </div>
            <br/><br/>
            <div id="cybs-logo">
              {imageComp}
              </div>
            <div>
              <p align="center">Use your EBC2 credentials to login and generate keys. <br/>
               Required fields are denoted by <mark class = "red">*</mark>.</p>
               <Textfield
                 dataTest="orgId-tf"
                 i18n={{
                   label: 'Organization ID',
                   errorText: orgIdState.errorText
                 }}
                 type="text"
                 value={orgId}
                 onChange={e => setOrgId(e.target.value)}
                 isInvalid={dialogActive && orgIdState.invalid}
                 onFocus={() => setDialogActive(true)}
                 onBlur={e => 
                    setOrgIdState({
                        ...orgIdState,
                        errorText: 
                          e.target.value === ''
                          ? 'This field is required.'
                          : '',
                        invalid: e.target.value === ''
                    })
                 }
                 required
               />
               <Textfield
                 dataTest="username-tf"
                 i18n={{
                   label: 'Username',
                   errorText: usernameState.errorText
                 }}
                 type="text"
                 value={username}
                 onChange={e => setUsername(e.target.value)}
                 isInvalid={dialogActive && usernameState.invalid}
                 onFocus={() => setDialogActive(true)}
                 onBlur={e => 
                    setUsernameState({
                        ...usernameState,
                        errorText: 
                          e.target.value === ''
                          ? 'This field is required.'
                          : '',
                        invalid: e.target.value === ''
                    })
                 }
                 required
               />
               <Textfield
                 dataTest="password-tf"
                 i18n={{
                   label: 'Password',
                   errorText: passwordState.errorText
                 }}
                 type={type}
                 iconClass = {icon}
                 resolution="low"
                 value={password}
                 onChange={e => setPassword(e.target.value)}
                 isInvalid={dialogActive && passwordState.invalid}
                 onFocus={() => setDialogActive(true)}
                 onBlur={e => 
                 setPasswordState({
                        ...passwordState,
                        errorText: 
                          e.target.value === ''
                          ? 'This field is required.'
                          : '',
                        invalid: e.target.value === ''
                    })
                 }
                 onIconClick={() => {
                   if(type==='password'){
                     setType('text');
                     setIcon('password-hide');
                   }
                   else{
                     setType('password');
                     setIcon('password-show');
                   }
                 }}
                 required
               />
               <br/>
               <p align="center"><Link class="color_theme_link" href={`${getPartnerConfigVal('ebcTestLoginLink') !== '' ? getPartnerConfigVal('ebcTestLoginLink') : "https://ebc2test.cybersource.com/ebc2/"}`} rel="noopener" target="_blank">Test Login</Link>&nbsp; | &nbsp;<Link class="color_theme_link" href={`${getPartnerConfigVal('ebcTestForgotPasswordLink') !== '' ? getPartnerConfigVal('ebcTestForgotPasswordLink') : "https://ebc2test.cybersource.com/ebc2/user/AccountRecovery"}`} rel="noopener" target="_blank">Forgot password?</Link> <br/>
                <div class = "copyright_content"></div>
               </p>
               </div>
              </div>
            }
            footerButtons={[
              {
                dataTest: 'generate-keys',
                label: buttonLabel,
                colorScheme: 'primary',
                disabled: disabled,
                onClick: () => {handleKMSGenerateKeys(orgId, username, password, setOpenLoader, props.setPositiveAlert,props.setNegativeAlert,props.changeOpenState,props.setP12)}
              }
            ]}
          />
      </div>
    )
}

export default KmsDialog;